import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/estudiantes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteEstudiantesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Estudiantes</PageTitle>
      <View />
    </>
  );
};

export { ReporteEstudiantesPage };
